var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelephoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Telephone Icon - Green"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Location Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25862",
    fill: "none",
    d: "M0 0h74v74H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32908"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32892"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Location Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25862",
    fill: "none",
    d: "M0 0h74v74H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Telephone Icon - Green"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32909"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 839",
    d: "M53.159 68.998a20.1 20.1 0 01-4.349-.575 51.069 51.069 0 01-13.1-4.6 58.738 58.738 0 01-13.7-9.746 58.949 58.949 0 01-11.552-15.232A51.23 51.23 0 015.39 24.314a17.892 17.892 0 01-.4-3.529 14.5 14.5 0 013.7-9.759 50.094 50.094 0 013.661-3.7 8.492 8.492 0 0111.779.1q3.251 3.094 6.345 6.351a8.548 8.548 0 01-.217 11.8l-2.581 2.583a3.552 3.552 0 00-.4 4.761 56.73 56.73 0 0013.815 13.8 3.546 3.546 0 004.689-.406c.917-.917 1.809-1.861 2.758-2.745a8.522 8.522 0 0111.829.083q3.223 3.08 6.3 6.312a8.454 8.454 0 01.291 11.306 32.7 32.7 0 01-4.844 4.705 14.7 14.7 0 01-8.956 3.022zm.021-2.992a11.215 11.215 0 007.417-2.645 42.582 42.582 0 004.106-4.051 5.5 5.5 0 00-.3-7.433q-3.023-3.051-6.074-6.073a5.594 5.594 0 00-7.825.025l-2.561 2.56a6.515 6.515 0 01-8.592.736 69.813 69.813 0 01-3.684-2.813 58.251 58.251 0 01-10.938-11.859 6.5 6.5 0 01.773-8.311c.916-.917 1.844-1.824 2.739-2.763a5.578 5.578 0 00-.09-7.758q-3-3.014-6.01-6.01a5.584 5.584 0 00-7.78-.083c-.987.946-1.943 1.922-2.908 2.89a11.653 11.653 0 00-2.291 3.228 12 12 0 00-.965 7.458 48.889 48.889 0 004.825 14.2 55.911 55.911 0 0011.137 14.688 55.761 55.761 0 0013.2 9.315 47.458 47.458 0 0011.164 4 20.443 20.443 0 004.657.699z",
    fill: "currentColor"
  }))))));
}

export default __webpack_public_path__ + "54465e42ea1d2c63e68525e36976ada3.svg";
export { SvgTelephoneIcon as ReactComponent };